import React from 'react'
import { useDispatch } from 'react-redux'
import Actions from '../../../actions'
import { clinicTypes, routes } from '../../../consts'
import $t from '../../../i18n'
import BotPreviewTemplate from '../../common/BotPreviewTemplate'

import './HtnBotPreview.css'

const HtnBotPreview = () => {
  const dispatch = useDispatch()

  const onExit = () => {
    dispatch(Actions.createAction(Actions.PRIMARY_CLINIC_CLICKED))
    dispatch(Actions.createAction(Actions.SEE_A_DOCTOR_CLICKED))
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        eventName: 'htn_bot_terminated_primary',
      })
    )
  }

  const onStart = () => {
    dispatch(Actions.createAction(Actions.HTN_BOT_INITED))
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        eventName: 'htn_bot_started',
      })
    )
  }

  const renderTitle = () => {
    return (
      <h1 className="bot-preview-title">
        {$t('pages.getStarted.htnBotPreview.welcome')}
        <br />
        {$t('pages.getStarted.htnBotPreview.hypertension')}
        <br />
        {$t('pages.getStarted.htnBotPreview.specialtyCareService')}
      </h1>
    )
  }

  const actions = [
    {
      title: $t('pages.getStarted.htnBotPreview.primary'),
      type: 'outlined',
      handleOnClick: onExit,
    },
    {
      title: $t('pages.getStarted.htnBotPreview.continue'),
      type: 'primary',
      handleOnClick: onStart,
    },
  ]

  return (
    <BotPreviewTemplate
      clinic={clinicTypes.HTN}
      actions={actions}
      contentTitle={renderTitle()}
      contentPoints={[
        $t('pages.getStarted.htnBotPreview.bullets.descriptionPoint1'),
        $t('pages.getStarted.htnBotPreview.bullets.descriptionPoint2'),
        $t('pages.getStarted.htnBotPreview.bullets.descriptionPoint3'),
        $t('pages.getStarted.htnBotPreview.bullets.descriptionPoint4'),
      ]}
    />
  )
}

export default HtnBotPreview
